if (!customElements.get('proh-stats-counter')) {
  class ProhStatsCounter extends HTMLElement {
    connectedCallback() {
      this.valueEl = this.querySelector('[data-counter-value]');
      this.target = Number.parseInt(this.dataset.target || '0', 10);
      this.duration = Number.parseInt(this.dataset.duration || '1800', 10);

      if (!this.valueEl || Number.isNaN(this.target)) return;

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.valueEl.textContent = `${this.target}`;
        return;
      }

      this.intersectionObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            this.runCounter();
            this.intersectionObserver.disconnect();
          });
        },
        { threshold: 0.5 }
      );

      this.intersectionObserver.observe(this);
    }

    disconnectedCallback() {
      if (this.intersectionObserver) {
        this.intersectionObserver.disconnect();
      }
    }

    runCounter() {
      const startValue = 0;
      const startTime = performance.now();

      const tick = (now) => {
        const progress = Math.min((now - startTime) / this.duration, 1);
        const currentValue = Math.round(startValue + (this.target - startValue) * progress);
        this.valueEl.textContent = `${currentValue}`;

        if (progress < 1) {
          requestAnimationFrame(tick);
        }
      };

      requestAnimationFrame(tick);
    }
  }

  customElements.define('proh-stats-counter', ProhStatsCounter);
}
